import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link } from 'react-router-dom'

const Services = () => {
  const serviceDetails = [
    {
      name: 'SaaS Product Development',
      description: 'We build custom software-as-a-service solutions tailored to your business needs. From concept to deployment, our team handles everything including UI/UX design, backend development, API integration, and ongoing maintenance.',
      features: [
        'Custom SaaS application development',
        'Cloud architecture and deployment',
        'API development and integration',
        'Scalable infrastructure',
        'Ongoing maintenance and support'
      ],
      icon: (
        <svg className="h-8 w-8 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
        </svg>
      )
    },
    {
      name: 'Email Marketing Campaigns',
      description: 'Our email marketing services help you build relationships with your audience through targeted, personalized campaigns that drive engagement and conversions.',
      features: [
        'Strategy development and planning',
        'List segmentation and management',
        'Responsive email design',
        'A/B testing and optimization',
        'Performance analytics and reporting'
      ],
      icon: (
        <svg className="h-8 w-8 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      )
    },
    {
      name: 'SEO Strategy & Implementation',
      description: 'Improve your organic search visibility with our comprehensive SEO services that combine technical optimization, content strategy, and link building.',
      features: [
        'Technical SEO audit',
        'Keyword research and strategy',
        'On-page optimization',
        'Content strategy and creation',
        'Link building and outreach'
      ],
      icon: (
        <svg className="h-8 w-8 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      )
    },
    {
      name: 'Google & Facebook Advertising',
      description: 'Maximize your advertising ROI with our data-driven approach to paid search and social media campaigns.',
      features: [
        'Campaign strategy development',
        'Audience targeting and segmentation',
        'Ad creative development',
        'Landing page optimization',
        'Performance tracking and optimization'
      ],
      icon: (
        <svg className="h-8 w-8 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
      )
    },
    {
      name: 'Social Media Marketing',
      description: 'Build your brand and engage your audience with strategic social media campaigns across all major platforms.',
      features: [
        'Platform-specific strategy',
        'Content calendar development',
        'Community management',
        'Influencer partnerships',
        'Performance analytics'
      ],
      icon: (
        <svg className="h-8 w-8 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
        </svg>
      )
    },
    {
      name: 'Content Marketing',
      description: 'Attract and retain customers through valuable, relevant content that establishes your brand as an industry authority.',
      features: [
        'Content strategy development',
        'Blog writing and management',
        'Video content production',
        'Infographic design',
        'Content distribution'
      ],
      icon: (
        <svg className="h-8 w-8 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
        </svg>
      )
    }
  ]

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <div className="bg-white">
          <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                Our Services
              </h1>
              <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
                Comprehensive digital marketing solutions tailored to your business goals.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gray-50">
          <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
            <div className="space-y-12">
              {serviceDetails.map((service) => (
                <div key={service.name} className="bg-white shadow rounded-lg overflow-hidden">
                  <div className="p-6 sm:p-8">
                    <div className="flex items-start">
                      <div className="flex-shrink-0">
                        <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary-100 text-primary">
                          {service.icon}
                        </div>
                      </div>
                      <div className="ml-4">
                        <h2 className="text-2xl font-bold text-gray-900">{service.name}</h2>
                        <p className="mt-2 text-gray-600">{service.description}</p>
                      </div>
                    </div>
                    <div className="mt-6">
                      <h3 className="text-lg font-medium text-gray-900">Key Features:</h3>
                      <ul className="mt-4 space-y-3">
                        {service.features.map((feature) => (
                          <li key={feature} className="flex items-start">
                            <div className="flex-shrink-0">
                              <svg className="h-5 w-5 text-primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                              </svg>
                            </div>
                            <p className="ml-2 text-gray-600">{feature}</p>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-6 py-4 sm:px-8">
                    <div className="flex justify-end">
                      <button
                        type="button"
                        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                      >
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="bg-white">
          <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
            <div className="bg-primary-700 rounded-lg shadow-xl overflow-hidden lg:grid lg:grid-cols-2 lg:gap-4">
              <div className="pt-10 pb-12 px-6 sm:pt-16 sm:px-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20">
                <div className="lg:self-center">
                  <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
                    <span className="block">Ready to grow your business?</span>
                    <span className="block">Let's talk about your project.</span>
                  </h2>
                  <p className="mt-4 text-lg leading-6 text-primary-200">
                    Schedule a free consultation with our team to discuss how we can help you achieve your marketing goals.
                  </p>
                  <Link
                    to="/contact"
                    className="mt-8 bg-white border border-transparent rounded-md shadow px-5 py-3 inline-flex items-center text-base font-medium text-primary-600 hover:bg-primary-50"
                  >
                    Contact Us
                  </Link>
                </div>
              </div>
              <div className="-mt-6 aspect-w-5 aspect-h-3 md:aspect-w-2 md:aspect-h-1">
                <img
                  className="transform translate-x-6 translate-y-6 rounded-md object-cover object-left-top sm:translate-x-16 lg:translate-y-20"
                  src="https://images.unsplash.com/photo-1520333789090-1afc82db536a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=80"
                  alt="App screenshot"
                />
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Services